import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToCompanyFilesListPage = () => {
  const { navigation } = useNavigation()

  const to = navigation.files.companyFiles.list.fullPath()

  return <Navigate replace to={to} />
}

export default RedirectToCompanyFilesListPage
